module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    style: (_vm.swipePosition)
  }, [_c('custom-toolbar', {
    style: (_vm.swipeTheme),
    attrs: {
      "modifier": "white-content"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-ons-toolbar-button', {
    attrs: {
      "slot": "right",
      "modifier": "white-content"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('splitter/toggle');
        _vm.showTip(null, 'Try dragging from right edge!')
      }
    },
    slot: "right"
  }, [_c('v-ons-icon', {
    attrs: {
      "icon": "ion-navicon, material:md-menu"
    }
  })], 1)], 1), _vm._v(" "), _c('v-ons-tabbar', {
    attrs: {
      "position": "auto",
      "modifier": "autogrow white-content",
      "swipeable": "",
      "on-swipe": _vm.md ? _vm.onSwipe : null,
      "tabbar-style": _vm.swipeTheme,
      "tabs": _vm.tabs,
      "index": _vm.index
    },
    on: {
      "update:index": function($event) {
        _vm.index = $event
      },
      "postchange": function($event) {
        _vm.showTip($event, 'Tip: Try swiping pages!')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20dfaf92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppTabbar.vue
// module id = 36
// module chunks = 0